<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #c7faf6;">
          <h5 class="card-title">Gestión de Informes</h5>
          <div class="row mb-3">
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Oficina: </label>
                  <select 
                    v-model="filters.oficina" 
                    class="form-select"
                  >
                    <option value="">Todos</option>  
                    <option value="dde">DDE-Beni</option>
                    <option value="minedu">Minedu</option>
                  </select>
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('informe_delete')"
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Unidad</th>
                    <th>Seccion</th>
                    <th>Informe</th>
                    <th>Tipo</th>
                    <th>Periodo</th>
                    <th>Gestion</th>
                    <th>Sol.Por</th>
                    <th>FechaSol.</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="informe in informes" :key="informe.id">
                    <td>{{ informe.codigo_unidad }}</td>
                    <td>{{ informe.codigo_area }}</td>
                    <td>{{ informe.informe }}</td>
                    <td>{{ informe.tipo }}</td>
                    <td>{{ informe.periodo }}</td>
                    <td>{{ informe.gestion }}</td>
                    <td>{{ informe.solicitado_por }}</td>
                    <td>{{ informe.fecha_solicitud }}</td>
                    <td>
                      <BBadge :variant="informe.estado === 'Aprobado' ? 'success' :informe.estado === 'Observado' ? 'danger' : 'warning'">
                        {{ informe.estado }}
                      </BBadge>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          variant="danger"
                          class="btn-round btn-sm"
                          @click="generateFormPDF(informe.id)"
                        >
                          <i class="fa fa-file-pdf me-1"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('informe_update')"
                          @click="showModal(informe)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Descripcion del Informe</label>
              <input
                type="text"
                v-model="form.descripcion"
                class="form-control"
                :class="{ 'is-invalid': errors.descripcion }"
                required
              />
              <div class="invalid-feedback" v-if="errors.descripcion">
                {{ errors.descripcion[0] }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Estado</label>
              <select
                v-model="form.estado"
                class="form-select"
                :class="{ 'is-invalid': errors.estado }"
                required
              >
                <option value="Aprobado">Aprobado</option>
                <option value="Observado">Observado</option>
              </select>
              <div class="invalid-feedback" v-if="errors.estado">
                {{ errors.estado[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-8" v-if="form.estado=='Observado'">
            <div class="form-group">
              <label class="form-label">Observacion</label>
              <input
                type="text"
                v-model="form.observacion"
                class="form-control"
                :class="{ 'is-invalid': errors.observacion }"
                required
              />
              <div class="invalid-feedback" v-if="errors.observacion">
                {{ errors.observacion[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Guardar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Informe {
  id: number; 
  descripcion: string;
  estado: string;
}

interface FormData {
  id: number | null;
  descripcion: string;
  estado: string;
}

interface Filters {
  oficina: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const informes = ref<Informe[]>([]);
    const loading = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      oficina: 'dde'
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const form = ref<FormData>({
      id: null,
      descripcion: '',
      estado: 'Aprobado',
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Informe' : 'Nuevo Informe';
    });

    const showModal = (informe: Informe | null) => {
      errors.value = {};
      if (informe) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: informe.id,
          descripcion: informe.descripcion,
          estado: 'Aprobado',
        };
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          descripcion: '',
          estado: 'Aprobado',
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/informe/update/${form.value.id}`, form.value);
        } else {
          response = await axios.post('/informe/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchInforme();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchInforme = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.oficina) {
          params.oficina = filters.value.oficina;
        }
        
        const response = await axios.get('/informe/list', { params });
        informes.value = response.data.informes.data || response.data.informes;
        
        // Actualizar paginación si la API la soporta
        if (response.data.informes.meta) {
          pagination.value = {
            current_page: response.data.informes.meta.current_page,
            per_page: response.data.informes.meta.per_page,
            total: response.data.informes.meta.total,
            last_page: response.data.informes.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar informes:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los informes'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchInforme();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchInforme();
    };
    
    const generateFormPDF = (id: number) => {
      axios.get(`/informe/reporte_economico/${id}`, {
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `tramite_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      const params = filters.value.oficina ? { oficina: filters.value.oficina } : {};
      
      axios.get('/informe/reporte', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-informes.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchInforme();
    });
    
    return {
      informes,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF,
      generateFormPDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>